var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhileCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00391 14.5V2.5H0.00390625V0.5H3.00391C3.5562 0.5 4.00391 0.94772 4.00391 1.5V13.5H16.4423L18.4423 5.5H6.00391V3.5H19.7231C20.2754 3.5 20.7231 3.94772 20.7231 4.5C20.7231 4.58176 20.7131 4.66322 20.6932 4.74254L18.1932 14.7425C18.082 15.1877 17.682 15.5 17.2231 15.5H3.00391C2.45163 15.5 2.00391 15.0523 2.00391 14.5ZM4.00391 21.5C2.89934 21.5 2.00391 20.6046 2.00391 19.5C2.00391 18.3954 2.89934 17.5 4.00391 17.5C5.10848 17.5 6.00391 18.3954 6.00391 19.5C6.00391 20.6046 5.10848 21.5 4.00391 21.5ZM16.0039 21.5C14.8993 21.5 14.0039 20.6046 14.0039 19.5C14.0039 18.3954 14.8993 17.5 16.0039 17.5C17.1085 17.5 18.0039 18.3954 18.0039 19.5C18.0039 20.6046 17.1085 21.5 16.0039 21.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhileCart);
export default __webpack_public_path__ + "static/media/while-cart.6a4c208da353db1202fe88eee49acd68.svg";
export { ForwardRef as ReactComponent };